module.exports = __webpack_public_path__ + "img/AS.89041b07.svg";